import { ExperimentOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import React from 'react';

interface LayoutActionsProps {
  currentUser: API.CurrentUser | null;
}

const LayoutActions: React.FC<LayoutActionsProps> = ({ currentUser }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return currentUser?.isAspiceSpecialist ? (
    <Button
      key="aspice"
      type="link"
      icon={<ExperimentOutlined />}
      onClick={() => navigate('/aspice/overview')}
    >
      {t('pages.layout.aspiceSpecialistInterface')}
    </Button>
  ) : null;
};

export default LayoutActions;
